import PocketBase from "pocketbase";
import { makeMockPb } from "./mockPb";

export type AppMode = "demo" | "live";

// A visitor can opt into the demo from the sign-in page even on a live deploy.
// It is a per-browser choice, so it survives a reload and never touches the
// server or anyone else's session.
const DEMO_FLAG = "ph.forceDemo";

export function demoRequested(): boolean {
  try { return localStorage.getItem(DEMO_FLAG) === "1"; } catch { return false; }
}

export function enterDemo(): void {
  try { localStorage.setItem(DEMO_FLAG, "1"); } catch { /* private mode */ }
  window.location.assign("/");
}

export function exitDemo(): void {
  try { localStorage.removeItem(DEMO_FLAG); } catch { /* private mode */ }
  window.location.assign("/");
}

// Same-origin: the Worker proxies /api/* to PocketBase over the tunnel.
// Override with VITE_PB_URL if you want the browser to hit PocketBase directly.
const base = import.meta.env.VITE_PB_URL || "/api";

// The client is chosen at runtime (see initPb). `pb` is a live ES-module
// binding, so importers always see the initialized instance as long as initPb()
// runs before the app renders (it does — main.tsx awaits it before mount).
// Typed as PocketBase so generic calls type-check; the mock is cast to it.
export let pb: PocketBase;
export let appMode: AppMode = "demo";

/**
 * Initialize the data client for the given mode.
 *  - "demo": in-browser mock seeded with sample data, persisted to localStorage.
 *  - "live": real PocketBase via the Worker /api proxy (or VITE_PB_URL).
 */
export function initPb(mode: AppMode): void {
  appMode = mode;
  pb = mode === "demo" ? (makeMockPb() as unknown as PocketBase) : new PocketBase(base);
  pb.autoCancellation(false);
}

export function isLoggedIn(): boolean {
  return !!pb?.authStore?.isValid;
}
